import React from 'react'

function Customers() {
  return (
    <div>
      {/* customers code can be written here */}
      <h2>I am from customers</h2>
    </div>
  )
}

export default Customers
